import { render, staticRenderFns } from "./SystemStepItem.vue?vue&type=template&id=507ec796&scoped=true&"
import script from "./SystemStepItem.vue?vue&type=script&lang=js&"
export * from "./SystemStepItem.vue?vue&type=script&lang=js&"
import style0 from "./SystemStepItem.vue?vue&type=style&index=0&id=507ec796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507ec796",
  null
  
)

export default component.exports